import React from "react";
import ReactDOM from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import "@/index.css";
import App from "@/App";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60_000,
      refetchOnWindowFocus: false,
    },
  },
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <App />
    </QueryClientProvider>
  </React.StrictMode>,
);

// Sicherheitsnetz: Scheitert das Laden eines JS-Teils (alte Version im
// Browser-Cache nach einem Deployment), einmalig Caches leeren und neu laden.
window.addEventListener("error", (event) => {
  const msg = String(event?.message || "");
  const isChunkError = /Loading chunk|ChunkLoadError|Loading CSS chunk/i.test(msg);
  if (!isChunkError || sessionStorage.getItem("chunk-reloaded")) return;
  sessionStorage.setItem("chunk-reloaded", "1");
  (async () => {
    try {
      if (window.caches) {
        const keys = await caches.keys();
        await Promise.all(keys.map((k) => caches.delete(k)));
      }
    } finally {
      window.location.reload();
    }
  })();
});

// Kein Offline-Cache mehr: Der Service Worker hat auf Mobilgeräten nach
// Deployments alte Versionen ausgeliefert. Bestehende Registrierungen werden
// entfernt und alle Caches geleert.
if ("serviceWorker" in navigator) {
  window.addEventListener("load", async () => {
    try {
      const regs = await navigator.serviceWorker.getRegistrations();
      await Promise.all(regs.map((r) => r.unregister()));
      if (window.caches) {
        const keys = await caches.keys();
        await Promise.all(keys.map((k) => caches.delete(k)));
      }
    } catch {
      /* nichts zu tun */
    }
  });
}
